.vs-chat-container {
  display: flex;
  flex-direction: column;
  font-family: 'visa-font-latin-light', 'visa-font-greek-light', 'visa-font-cyrillic-light';
  height: 100%;
  width: 100%;
  border: 1px none #ddd;
  margin: 0 auto;
  transition: all 0.3s ease-in-out;
  transform: scale(0);
  background-color: white; /* Set your desired background color */
  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.15);
  outline: 1px solid transparent; /* Transparent outline for sharp edges */
}

.vs-chat-container.opening {
  animation: open-box 0.3s ease-in-out forwards;
}

@keyframes open-box {
  from {
    transform: scale(0.8) rotateX(-10deg);
  } /* Initial state with slight scale and rotation */
  to {
    transform: scale(1) rotateX(0deg);
  } /* Final state: full scale and no rotation */
}

.vs-chat-main-container {
  align-items: flex-end;
  bottom: 20px;
  display: flex;
  justify-content: center;
  padding: 0;
  margin: 0;
  position: fixed;
  right: 20px;
  z-index: 100 !important;
}

.vs-chat-main-container[data-chat='chat-closed'] {
  width: 100px;
  height: 52px;
}

.vs-chat-main-container[data-chat='chat-open'] {
  width: 400px;
  height: 550px;
}

.chat-history,
.end-chat-history {
  overflow: auto;
  word-break: break-word;
  display: flex;
  height: 100%;
  flex-direction: column;
  /* overflow-x: hidden; */
}
.message > p {
  color: black !important;
}

.chat-input {
  display: flex;
  bottom: 0px;
  width: -webkit-fill-available;
  margin-top: auto;
  padding-top: 10px;
  position: relative;
}

.chat-input #vs-chat-input {
  flex: 1; /* Expands to fill the available space */
  padding: 0.375rem 10px 0.375rem 10px;
  border: 1px solid rgba(222, 222, 222, 1);
  border-top: 1px solid rgba(222, 222, 222, 1);
  background: rgba(255, 255, 255, 1);
  border-bottom: none;
  border-left: none;
  border-right: none;
  font-family: 'visa-font-latin-light', 'visa-font-greek-light', 'visa-font-cyrillic-light';
  font-size: 17px;
  width: 100%;
  color: #2c2c2c;
  height: 72px;
  resize: none;
}
.chat-input #vs-chat-input.vs-pt-23 {
 padding-top: 23px !important;
}
.chat-input .vs-chat-input-label {
  position: absolute;
  left: 10px;
  transition: 0.2s ease all;
  color: #808080;
  font-size: 13px;
  font-weight: 300;
  margin-top: 8px;
}
.chat-input #vs-chat-input:focus {
  outline: none;
  caret-color: #1431cb;
}
.chat-input #vs-chat-input::placeholder {
  padding-left: 10px;
}

.chat-input .vs-chat-enter {
  padding: 10px 20px;
  color: white;
  border: none;
  cursor: pointer;
  border-top: 1px solid gray;
  border-bottom: none;
  border-right: none;
  border-left: none;
}

/* //sticky button  */

.vs-chat-sticky-button-container {
  position: fixed;
  bottom: 20px;
  right: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 53px;
}

.vs-sticky-button {
  font-family: 'visa-font-latin-semi-bold', 'visa-font-greek-light', 'visa-font-cyrillic-light';
  border: none;
  border-radius: 50px;
  cursor: pointer;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease-in-out;
  background-color: #1434cb;
  color: #fff;
  font-size: 18px;
  height: 52px;
  padding: 7px 15px;
}
.vs-chat-title-heading {
  font-weight: 600;
}

.vs-chat-title-container {
  display: flex;
  margin: 0;
  justify-content: space-between;
  font-family: 'visa-font-latin-semi-bold', 'visa-font-greek-light', 'visa-font-cyrillic-light';
  font-size: 18px;
  align-items: center;
  padding: 5px 10px;
  background-color: #1434cb;
  font-weight: 300;
  color: white;
  height: 50px;
  /* Optional to separate from chat history */
}

.vs-sticky-button:hover {
  background: #3b57de;
}
.vs-sticky-button:focus {
  outline: 1px dashed var(--button-primary-border-focus);
  outline-offset: -4px;
}

.chat-img {
  background-repeat: no-repeat; /* Prevent image tiling */
  background-size: cover; /* Scale image to cover the container */
  width: 35px;
  justify-content: center;
  padding: 3px;
  align-items: center;
  height: 26px;
  fill: #fcc015;
  margin: 0;
}
.vs-align-center-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.message {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.chatbot > div {
  clear: both;
  margin-top: 12px;
}

.message.user {
  float: right;
  width: fit-content;
  border: 1px solid rgba(128, 128, 128, 1);
  border-radius: 10px;
  justify-content: flex-end;
  align-self: flex-end;
  margin: 15px 15px 15px 60px;
}

.message.chatbot {
  margin: 0;
  align-items: flex-start;
  display: flex;
  flex-direction: row;
  width: 100%;
  /* padding-right: 10px; */
}

.message img {
  height: 50px;
  margin-right: 5px; /* Adjust for alignment */
}

.timestamp {
  font-size: 12px;
  color: #999;
  margin-left: 10px; /* Adjust for alignment */
}

.vs-flex-align-end {
  align-items: flex-end;
  flex-grow: 0;
  display: flex;
  justify-content: center;
  align-items: center ;
  margin-left: auto;
  cursor: pointer;
}
.vs-arrow {
  background-color: #1434cb;
}
.vs-arrow::before {
  text-decoration: none;
  content: '\e804b';
  color: #fcc015;
  display: inline-block;
  font-family: 'visa-icon';
  font-size: 15px;
}
.vs-message-brain-icon {
  margin-top: 10px;
  background: white !important;
}
.vs-bot-response {
  padding: 12px;
  border-radius: 15px;
  line-height: 18px;
  background-color: #f7f7f7;
  margin-right: 15px;
  margin-top: 12px;
  width: 100%;
}
/* The typing effect */
@keyframes typing {
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
}

/* The typewriter cursor effect */
@keyframes blink-caret {
  from,
  to {
    border-color: transparent;
  }
  50% {
    border-color: orange;
  }
}
.vs-bot-response > p {
  margin-block-start: initial !important;
  -webkit-font-smoothing: antialiased;
  color: black;
}

.vs-bot-response > p > a.vs-link-cta {
  margin: 0 !important;
}

.vs-bot-response > p.typing {
  animation:
    typing 3.5s steps(40, end),
    blink-caret 0.75s step-end infinite;
  animation-timing-function: cubic-bezier(0.05, 0.7, 0.91, 1);
}

.vs-bot-response-container {
  background-color: #f7f7f7;
  padding-bottom: 5px;
  border-radius: 15px;
  margin-top: 12px;
}
.vs-user-input-bot {
  margin: 2px;
  padding: 11px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 18px;
  font-family: 'visa-font-latin-light', 'visa-font-greek-light', 'visa-font-cyrillic-light';
  margin-block-end: auto !important;
  margin-block-start: auto !important;
  margin-inline-end: auto !important;
  margin-inline-start: auto !important;
}

.transition-smooth {
  transition: all 0.3s ease-in-out;
  overflow-y: auto;
}
.transition {
  transition: opacity 0.5s ease-in-out;
}
.vs-chat-container {
  font-size: 14px;
}

.dot-typing {
  position: relative;
  left: -9999px;
  width: 7px;
  height: 7px;
  border-radius: 5px;
  background-color: #1431cb;
  color: #1431cb;
  box-shadow:
    9984px 0 0 0 #1431cb,
    9999px 0 0 0 #1431cb,
    10014px 0 0 0 #1431cb;
  animation: dot-typing 1.5s infinite linear;
  margin-left: 15px;
}

@keyframes dot-typing {
  0% {
    box-shadow:
      9984px 0 0 0 #1431cb,
      9999px 0 0 0 #1431cb,
      10014px 0 0 0 #1431cb;
  }
  16.667% {
    box-shadow:
      9984px -10px 0 0 #1431cb,
      9999px 0 0 0 #1431cb,
      10014px 0 0 0 #1431cb;
  }
  33.333% {
    box-shadow:
      9984px 0 0 0 #1431cb,
      9999px 0 0 0 #1431cb,
      10014px 0 0 0 #1431cb;
  }
  50% {
    box-shadow:
      9984px 0 0 0 #1431cb,
      9999px -10px 0 0 #1431cb,
      10014px 0 0 0 #1431cb;
  }
  66.667% {
    box-shadow:
      9984px 0 0 0 #1431cb,
      9999px 0 0 0 #1431cb,
      10014px 0 0 0 #1431cb;
  }
  83.333% {
    box-shadow:
      9984px 0 0 0 #1431cb,
      9999px 0 0 0 #1431cb,
      10014px -10px 0 0 #1431cb;
  }
  100% {
    box-shadow:
      9984px 0 0 0 #1431cb,
      9999px 0 0 0 #1431cb,
      10014px 0 0 0 #1431cb;
  }
}

.vs-chat-main-container .visa-document-button {
  font-family: 'visa-font-latin-light', 'visa-font-greek-light', 'visa-font-cyrillic-light' !important;
  font-size: 14px;
  border-radius: 25px;
  border: 1px solid #b9b9b9;
  margin: 0px;
  padding: 5px;
  display: flex;
  width: fit-content;
  align-items: center;
  padding: 10px;
  background-color: white;
  margin: 5px;
  cursor: pointer;
  color: #2c2c2c;
}

.visa-document-button:hover,
.visa-document-button:focus {
  border-color: #2c2c2c;
}
.visa-document-button:focus {
  outline: 1px dashed black;
  outline-offset: -5px;
}
.vs-text-left {
  text-align: left;
  padding: 4px;
  margin-left: 5px;
}
.vs-chat-main-container .visa-icon-search-md:before {
  font-size: 16px;
  font-family: 'visa-font';
  color: #2c2c2c;
}

.vs-chat-main-container .visa-icon.visa-icon-search-md::before {
  font-size: 16px;
}

.vs-accordion-header {
  font-family: var(--link-font-family, 'sans-serif');
  width: fit-content;
  font-weight: 400;
  padding: 10px;
  cursor: pointer;
  color: var(--link-color, #1434cb);
  font-size: 17px;

}

.vs-chat-container > a.vs-link-cta {
  display: block;
  font-size: 14px !important;
  margin: 4px !important;
  padding-bottom: 7px;
}

/* START GENAI@CHATGPT4 */

/* Add a media query for mobile devices */
@media (max-width: 768px) {
  .vs-chat-main-container {
    /* Set the width and height to 100% to make it full screen. */
    width: 100dvw;
    height: 100dvh;
    right: 0;
    position: fixed !important;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 9999;
  }
  .vs-chat-main-container[data-chat='chat-closed'] {
    width: min-content !important;
    height: min-content !important;
  }

  .vs-chat-main-container[data-chat='chat-open'] {
    width: 100dvw;
    height: 100dvh;
  }

  .vs-chat-container {
    /* Set the width and height to 100% to make it full screen. */
    width: 100dvw;
    height: 100dvh !important;
    /* Remove the border */
    border: none;
    /* Remove the box shadow */
    box-shadow: none;
  }
  .vs-chat-main-container .vs-sticky-button {
    height: 53px;
    width: 53px;
  }
  .vs-chat-main-container .vs-chat-btn-text {
    display: none;
  }
  .vs-chat-main-container .vs-chat-btn-icon {
    margin-right: 0px;
  }
  .no-page-scroll {
    overflow: hidden;
    height: 100vh;
  }
  body.vs-modal-body .vs-chat-main-container {
    z-index: 1 !important;
  }
}

/* END GENAI@CHATGPT4 */

.vs-chat-box-element {
  width: 95%;
  border: 1px solid rgba(185, 185, 185, 1);
  border-radius: 10px;
  font-size: 14px;
  color: rgba(92, 92, 92, 1);
  margin: 10px;
  background: #fff;
}

.line {
  height: 55px;
  border-bottom: 1px solid rgba(185, 185, 185, 1);
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.line:hover {
  background-color: #f7f7f7;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
  color: black;
}
.line:hover:last-child {
  border-radius: 10px;
}
.line:hover:first-child {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.line:last-child {
  border-bottom: none;
}

.line:focus {
  outline: 1px dashed black;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
}
.line:focus:first-child {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.line:focus:last-child {
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
.vs-chat-svg {
  height: 30px;
  margin-right: 7px;
}
.snippet {
  margin: 20px;
  padding: 10px;
}
.vs-grey-bg {
  background-color: #f7f7f7;
  width: 100%;
  padding: 20px;
  border-radius: 15px;
}
.vs-mt-20 {
  margin-top: 20px !important;
}

.vs-d-flex-align-c {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}
.vs-flex-d-column {
  flex-direction: column;
}
a.vs-main-menu-link.vs-link-cta {
  font-size: 17px !important;
}
.vs-disabled-action,
.vs-disabled-action:hover {
  opacity: 50%;
  pointer-events: none;
}
a.vs-chat-inline {
  display: inline !important;
  margin: 0 !important;
}
/* .vs-minimize-icon:before {
  position: relative;
  top: 8px;
  margin: 5px;
} */

.vs-chat-container button.vs-minimize-icon {
  position: relative;
  padding-top: 10px;
  padding-bottom: 0px;
}

.vs-chat-container button.visa-icon-close-sm,
.vs-chat-container button.vs-minimize-icon {
  cursor: pointer;
  border: 0;
  margin: 0;
  background-color: rgba(0, 0, 0, 0);
}

.vs-chat-container button.visa-icon-close-sm:before,
.vs-chat-container button.vs-minimize-icon:before {
  color: white;
  font-size: 16px;
}

.vs-chat-container button.visa-icon-close-sm:hover:before,
.vs-chat-container button.vs-minimize-icon:hover:before,
.vs-chat-container button.visa-icon-close-sm:focus:before,
.vs-chat-container button.vs-minimize-icon:focus:before {
  opacity: 0.9;
}

.vs-chat-container button.visa-icon-close-sm:focus,
.vs-chat-container button.vs-minimize-icon:focus {
  outline: 1px dashed white;
  outline-offset: 2px;
}

.vs-d-none {
  display: none !important;
}
.vs-h100 {
  height: 100%;
}
.vs-w90 {
  width: 90%;
}
.vs-mt-10 {
  margin-top: 10px !important;
}
.vs-text-align-c {
  text-align: center;
}
.vs-font-size-17 {
  font-size: 17px;
}
.vs-line-0 {
  line-height: 0px !important;
}
.vs-light-text-color {
  color: rgba(44, 44, 44, 1);
}
.vs-chat-container .sources a.vs-font-14 {
  font-size: 14px;
  display: block;
  margin-bottom: 8px;
  text-decoration: underline;
}
.vs-chat-container a.vs-font-14.vs-link-cta.vs-link-new-window::after{
  font-size: 12px;
  display: inline-block;
}
.vs-bot-response p a {
  font-size: 14px;
}
.vs-bold-text {
  font-family: var(--display-font-family);
  font-size: 33px;
  font-weight: 600;
  padding: 12px;
}
.vs-disabled-input {
  background-color: #f7f7f7;
  border: 1px solid #f7f7f7;
  color: #999;
  cursor: not-allowed;
}
.vs-chat-dot {
  position: absolute;
  width: 12px;
  height: 12px;
  background: red;
  border-radius: 50%;
  top: 8px; /* Adjust this to move the dot up or down */
  left: 8px; /* Adjust this to move the dot right or left */
  transform: translate(-50%, -50%);
}
.vs-btn-white-bg {
  background-color: #fff;
}

.vs-chat-container .visa-icon-close-sm.vs-btn-white-bg::before {
  color: #565656;
  border-top: none !important;
}
.vs-chat-container .visa-icon-close-sm.vs-btn-white-bg:hover::before,.vs-chat-container .visa-icon-close-sm.vs-btn-white-bg:focus::before {
  color: #2c2c2c;
}

.vs-chat-container button.vs-chat-clear {
  padding: 10px;
  color: white;
  border: none;
  cursor: pointer;
  border-top: 1px solid #dedede;
}

.vs-chat-container button.vs-chat-clear:focus {
  outline: 1px dashed black;
  outline-offset: -5px;
}

.vs-chat-container button.vs-chat-enter:focus {
  outline: 1px dashed white;
  outline-offset: -5px;
}

.vs-chat-container .vs-circle-icon {
  display: flex;
  border-radius: 50%;
  border: 1px solid var(--ds-tertiary-4-color, #b9b9b9);
  padding: 5px;
  margin-right: 10px;
  height: 50px;
  width: 50px;
  align-items: center;
  align-content: stretch;
  justify-content: space-evenly;
  cursor: pointer;
  background-color: white;
}
.vs-chat-container .vs-circle-icon:hover,
.vs-chat-container .vs-circle-icon:focus {
  border: 1px solid var(--ds-tertiary-6-color, #5c5c5c);
}

.vs-chat-container .vs-circle-icon:focus {
  outline: 1px dashed black;
  outline-offset: -5px;
}
.vs-chat-container .visa-icon-thumbs-up-reverse::before,
.vs-chat-container .visa-icon-thumbs-down-reverse::before {
  color: #1431cb;
  font-size: 24px;
}
.vs-chat-container .vs-feedback-icon-container {
  display: flex;
  align-items: center;
  padding: 10px;
}

.vs-chat-container .vs-feedback-icon-container .vs-chat-feedback-radio {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}
.vs-chat-container .vs-radio-button-container:focus-within .vs-circle-icon {
  outline: 1px dashed black;
  outline-offset: -5px;
}

.vs-radio-button-container.liked .visa-icon-thumbs-up-reverse::before {
  font-family: 'visa-icon';
  content: "\e9366";
}

.vs-radio-button-container.disliked .visa-icon-thumbs-down-reverse::before {
  font-family: 'visa-icon';
  content: "\e9367";
}

.visa-icon-thumbs-up-reverse:before {
  font-family: 'visa-icon';
  content: "\e9365";
}
.visa-icon-thumbs-down-reverse:before {
  font-family: 'visa-icon';
  content: "\e9364";
}
.vs-pointer-none a, .vs-pointer-none button {
  pointer-events: none;
}
/* START GENAI@CHATGPT4 */
input[type="radio"][name^="vs-chat-ldl-"]:disabled, .vs-chat-container .vs-disabled-feedback .vs-circle-icon {
  opacity: 0.6;
  cursor: not-allowed;
}
/* END GENAI@CHATGPT4 */
.vs-chat-disclaimer-container {
  display: flex;
  font-family: 'visa-font-latin-semi-bold', 'visa-font-greek-light', 'visa-font-cyrillic-light';
  flex-direction: column;
  padding: 15px 10px 15px 20px;
  color: black;
  height: auto;
  width: 100%;
  background-color: #FFEE9A;
  position: absolute;
  bottom: 0;
}

.vs-chat-disclaimer-container h2.vs-chat-title-heading {
  margin-top: 0px;
  margin-bottom: 5px;
  font-size: 14px;
  line-height: 18px;
}

.vs-chat-disclaimer-container p.vs-text {
  font-size: 11px;
  line-height: 16px;
  font-weight: 300;
  color: #000;
  margin-bottom: 0px;
}

.vs-chat-disclaimer-container p.vs-text a.vs-link-cta, .vs-chat-disclaimer-container p.vs-text a.vs-link-cta:after{
  text-decoration: none;
  font-size: 11px;
  line-height: 16px;
  font-weight: 300;
}

.vs-chat-disclaimer-container button.visa-icon-close-sm:before {
  cursor: pointer;
  border: 0;
  margin: 0;
  color: #5C5C5C;
}

.vs-chat-disclaimer-container button.visa-icon-close-sm:hover:before,
.vs-chat-disclaimer-container button.visa-icon-close-sm:focus:before {
  color: #2c2c2c;
}

.vs-chat-disclaimer-container button.visa-icon-close-sm:focus:before {
  outline: 1px dashed black;
  outline-offset: 5px;
}

.vs-chat-disclaimer-container button.visa-icon-close-sm:focus{
  outline: none;
}

/* Add a media query for mobile devices */
@media (max-width: 768px) {
  .vs-chat-disclaimer-container{
    width: 100%;
  }

}
